(function () {
  'use strict';
  var radice = document.documentElement;
  var CLASSE_ATTESA = 'l73-esauriti-attesa';

  function marcatore() { return document.querySelector('[data-l73-esauriti-in-fondo]'); }

  function idDi(li) { return li.getAttribute('data-product-id'); }
  function esaurito(li) {
    var f = li.getAttribute('data-l73-in-fondo');
    return f === null ? li.getAttribute('data-available') === 'false' : f === 'true';
  }

  function paginaDallUrl() {
    var p = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
    return isNaN(p) ? 1 : p;
  }

  function contatore(stato) {
    var el = document.querySelector('infinite-scrolling');
    if (!el) return;
    var fine = el.querySelector('[data-total-end]');
    var barra = el.querySelector('.pagination-total-item');
    var visti = stato.grid.querySelectorAll(':scope > .product-grid__item').length;
    if (fine) fine.textContent = visti;
    if (barra && stato.totale > 0) barra.style.width = Math.min(100, visti / stato.totale * 100) + '%';
    var prog = el.querySelector('.pagination-total-progress');
    if (prog) { prog.setAttribute('aria-valuenow', visti); prog.setAttribute('aria-valuemax', stato.totale); }
  }

  function riattiva(stato, nuovi) {
    try {
      if (window.lazyLoad) window.lazyLoad.update();
      if (window.animateOnScroll) window.animateOnScroll.init();
      nuovi.forEach(function (li) {
        li.querySelectorAll('[data-quick-add]').forEach(function (b) { if (window.QuickAdd) window.QuickAdd.initButton(b); });
      });
      if (typeof window.initMoreSwatchButtons === 'function') window.initMoreSwatchButtons(stato.grid);
      document.dispatchEvent(new CustomEvent('productsLoaded', { detail: { page: stato.pagina, totalPages: stato.pagine, hasNextPage: !stato.finito } }));
    } catch (e) { }
  }

  function metti(stato, li) {
    var id = idDi(li);
    if (id && stato.visti.has(id)) return false;
    if (id) stato.visti.add(id);
    if (esaurito(li)) { stato.tenuti.push(li); return false; }
    stato.grid.appendChild(li);
    return true;
  }

  function versaEsauriti(stato) {
    var nuovi = [];
    if (!stato.tenuti.length) return nuovi;
    stato.tenuti.splice(0, stato.blocco).forEach(function (li) {
      li.classList.add('l73-in-fondo');
      li.setAttribute('data-page', 'esauriti');
      stato.grid.appendChild(li);
      nuovi.push(li);
    });
    return nuovi;
  }

  function urlPagina(stato, n) {
    var u = new URL(window.location.href);
    u.searchParams.set('page', n);
    u.searchParams.set('section_id', stato.sezione);
    return u.toString();
  }

  async function prossimo(stato, el) {
    var nuovi = [];
    if (stato.pagina < stato.pagine) {
      var n = stato.pagina + 1;
      var r = await fetch(urlPagina(stato, n));
      if (!r.ok) throw new Error('pagina ' + n + ': ' + r.status);
      var doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      var g = doc.querySelector('.product-grid');
      if (g && parseInt(g.dataset.totalPages, 10)) stato.pagine = parseInt(g.dataset.totalPages, 10);
      doc.querySelectorAll('.product-grid__item').forEach(function (li) {
        var c = document.importNode(li, true);
        c.setAttribute('data-page', n);
        if (metti(stato, c)) nuovi.push(c);
      });
      stato.pagina = n;
      el.currentPage = n;
      stato.grid.dataset.currentPage = n;
      if (!(doc.querySelectorAll('.product-grid__item').length)) stato.pagina = stato.pagine;
    } else {
      nuovi = versaEsauriti(stato);
    }
    stato.finito = stato.pagina >= stato.pagine && !stato.tenuti.length;
    return nuovi;
  }

  async function carica(stato, el) {
    if (el.isLoading || stato.finito) { el.hasNextPage = !stato.finito; return; }
    el.isLoading = true;
    el.showLoadingState();
    var nuovi = [];
    try {
      nuovi = await prossimo(stato, el);
      stato.errori = 0;
    } catch (e) {
      console.error('L73 esauriti in fondo:', e);
      stato.errori += 1;
      stato.catena = 99;
      if (stato.errori >= 3) {
        stato.pagine = stato.pagina;
        stato.finito = !stato.tenuti.length;
      }
    } finally {
      el.hasNextPage = !stato.finito;
      el.hideLoadingState();
      el.isLoading = false;
    }
    if (stato.finito) {
      var b = el.querySelector('[data-infinite-scrolling]');
      if (b) b.style.display = 'none';
    }
    contatore(stato);
    if (nuovi.length) riattiva(stato, nuovi);
    continua(stato, el, nuovi.length);
  }

  function continua(stato, el, aggiunti) {
    if (stato.finito || !el.isConnected) return;
    stato.catena = aggiunti ? 0 : stato.catena + 1;
    if (stato.catena > 5) return;
    var b = el.querySelector('[data-infinite-scrolling]');
    if (!b) return;
    window.requestAnimationFrame(function () {
      var r = b.getBoundingClientRect();
      var inVista = r.bottom > 0 && r.top < window.innerHeight + 200;
      if (inVista && (aggiunti < stato.blocco || r.top < window.innerHeight)) setTimeout(function () { el.loadNextPage(); }, 150);
    });
  }

  function prendiInCarico() {
    var m = marcatore();
    var grid = document.querySelector('#ResultsList .product-grid');
    if (!m || !grid || grid.__l73Esauriti !== undefined) return;
    grid.__l73Esauriti = null;
    if (paginaDallUrl() > 1) { radice.classList.remove(CLASSE_ATTESA); return; }
    var stato = {
      grid: grid,
      sezione: grid.dataset.id,
      pagina: parseInt(grid.dataset.currentPage, 10) || 1,
      pagine: parseInt(grid.dataset.totalPages, 10) || 1,
      blocco: parseInt(grid.dataset.pageSize, 10) || 32,
      totale: parseInt(grid.dataset.totalItems, 10) || 0,
      visti: new Set(), tenuti: [], finito: false, errori: 0, catena: 0
    };
    Array.prototype.slice.call(grid.querySelectorAll(':scope > .product-grid__item')).forEach(function (li) {
      var id = idDi(li);
      if (id && stato.visti.has(id)) { li.remove(); return; }
      if (id) stato.visti.add(id);
      if (esaurito(li)) { li.remove(); stato.tenuti.push(li); }
    });
    grid.__l73Esauriti = stato;
    var el = document.querySelector('infinite-scrolling');
    if (!el) {
      while (stato.tenuti.length) versaEsauriti(stato);
      stato.finito = true;
    } else {
      stato.finito = stato.pagina >= stato.pagine && !stato.tenuti.length;
      el.hasNextPage = !stato.finito;
      var b = el.querySelector('[data-infinite-scrolling]');
      if (b && !stato.finito) b.style.display = '';
      contatore(stato);
      continua(stato, el, grid.querySelectorAll(':scope > .product-grid__item').length);
    }
    radice.classList.remove(CLASSE_ATTESA);
  }

  customElements.whenDefined('infinite-scrolling').then(function () {
    var proto = customElements.get('infinite-scrolling').prototype;
    if (proto.__l73Esauriti) return;
    var originale = proto.loadNextPage;
    proto.loadNextPage = function () {
      if (!this.isConnected) return Promise.resolve();
      var g = this.productGrid && this.productGrid.isConnected ? this.productGrid : document.querySelector('#ResultsList .product-grid');
      if (g && g.__l73Esauriti) { this.productGrid = g; return carica(g.__l73Esauriti, this); }
      return originale.apply(this, arguments);
    };
    proto.__l73Esauriti = true;
  });

  function avvia() {
    prendiInCarico();
    var cont = document.getElementById('ProductGridContainer');
    if (cont) new MutationObserver(function () { prendiInCarico(); }).observe(cont, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
